export const CHANGE_INPUT_BUDGET = 'OMAKASE_PLAN/CHANGE_INPUT_BUDGET';
export const CHANGE_INPUT_TERM = 'OMAKASE_PLAN/CHANGE_INPUT_TERM';
export const CHANGE_INPUT_POLICY = 'OMAKASE_PLAN/CHANGE_INPUT_POLICY';
export const SET_CREATING_STRATEGY_LIST = 'OMAKASE_PLAN/SET_CREATING_STRATEGY_LIST';
export const SET_CREATING_INPUT = 'OMAKASE_PLAN/SET_CREATING_INPUT';
export const SET_CREATING_RESULT = 'OMAKASE_PLAN/SET_CREATING_RESULT';
export const SET_CREATING_INPUT_SET_COUNT = 'OMAKASE_PLAN/SET_CREATING_INPUT_SET_COUNT';
export const SET_CREATING_INPUT_SET_COUNT_ALL = 'OMAKASE_PLAN/SET_CREATING_INPUT_SET_COUNT_ALL';
export const RESET_CREATING_INPUT_SET_COUNT = 'OMAKASE_PLAN/RESET_CREATING_INPUT_SET_COUNT';
export const EDIT_CREATING_ERROR_MESSAGES = 'OMAKASE_PLAN/EDIT_CREATING_ERROR_MESSAGES';
export const SET_CREATING_STRATEGY_LIST_CACHE = 'OMAKASE_PLAN/SET_CREATING_STRATEGY_LIST_CACHE';
export const CHANGE_CREATING_SIMULATION_TERM_ID = 'OMAKASE_PLAN/CHANGE_CREATING_SIMULATION_TERM_ID';
export const CHANGE_CREATING_SELECTED_STRATEGY_ID = 'OMAKASE_PLAN/CHANGE_CREATING_SELECTED_STRATEGY_ID';
export const SET_OMAKASE_PLAN_MASTER = 'OMAKASE_PLAN/SET_OMAKASE_PLAN_MASTER';
export const SET_OMAKASE_PLAN_LOADING = 'OMAKASE_PLAN/SET_OMAKASE_PLAN_LOADING';
export const FIND_OMAKASE_PLAN_STRATEGIES = 'OMAKASE_PLAN/FIND_OMAKASE_PLAN_STRATEGIES';
export const INITIALIZE_OMAKASE_INPUT = 'OMAKASE_PLAN/INITIALIZE_OMAKASE_INPUT';
export const SET_OMAKASE_PLAN_SUBMIT_PROCESSING = 'OMAKASE_PLAN/SET_OMAKASE_PLAN_SUBMIT_PROCESSING';
export const CREATE_OMAKASE_PLAN_REQUEST = 'OMAKASE_PLAN/CREATE_OMAKASE_PLAN_REQUEST';
export const GET_PORTFOLIOS_REQUEST_START_LOADING = 'OMAKASE_PLAN/GET_PORTFOLIOS_REQUEST_START_LOADING';
export const GET_PORTFOLIOS_REQUEST_END_LOADING = 'OMAKASE_PLAN/GET_PORTFOLIOS_REQUEST_END_LOADING';
export const GET_PORTFOLIOS_REQUEST = 'OMAKASE_PLAN/GET_PORTFOLIOS_REQUEST';
export const GET_PORTFOLIOS_SUCCESS = 'OMAKASE_PLAN/GET_PORTFOLIOS_SUCCESS';

export const GET_PORTFOLIO_DETAIL_REQUEST_START_LOADING = 'OMAKASE_PLAN/GET_PORTFOLIO_DETAIL_REQUEST_START_LOADING';
export const GET_PORTFOLIO_DETAIL_REQUEST_END_LOADING = 'OMAKASE_PLAN/GET_PORTFOLIO_DETAIL_REQUEST_END_LOADING';
export const GET_PORTFOLIO_DETAIL_REQUEST = 'OMAKASE_PLAN/GET_PORTFOLIO_DETAIL_REQUEST';
export const GET_PORTFOLIO_DETAIL_SUCCESS = 'OMAKASE_PLAN/GET_PORTFOLIO_DETAIL_SUCCESS';

export const CREATE_AP_GROUP_REQUEST = 'OMAKASE_PLAN/CREATE_AP_GROUP_REQUEST';
export const CREATE_AP_GROUP_REQUEST_START_LOADING = 'OMAKASE_PLAN/CREATE_AP_GROUP_REQUEST_START_LOADING';
export const CREATE_AP_GROUP_REQUEST_END_LOADING = 'OMAKASE_PLAN/CREATE_AP_GROUP_REQUEST_END_LOADING';

export const CHANGE_NAME_REQUEST = 'OMAKASE_PLAN/CHANGE_NAME_REQUEST';
export const CHANGE_NAME_REQUEST_START_LOADING = 'OMAKASE_PLAN/CHANGE_NAME_REQUEST_START_LOADING';
export const CHANGE_NAME_REQUEST_END_LOADING = 'OMAKASE_PLAN/CHANGE_NAME_REQUEST_END_LOADING';

export const GET_OMAKASE_PLAN_MASTER_REQUEST_START_LOADING =
  'OMAKASE_PLAN/GET_OMAKASE_PLAN_MASTER_REQUEST_START_LOADING';
export const GET_OMAKASE_PLAN_MASTER_REQUEST_END_LOADING = 'OMAKASE_PLAN/GET_OMAKASE_PLAN_MASTER_REQUEST_END_LOADING';
export const GET_OMAKASE_PLAN_MASTER_REQUEST = 'OMAKASE_PLAN/GET_OMAKASE_PLAN_MASTER_REQUEST';
export const GET_OMAKASE_PLAN_MASTER_SUCCESS = 'OMAKASE_PLAN/GET_OMAKASE_PLAN_MASTER_SUCCESS';
